export enum LibraryViews {
  ALL = 'all',
  STUDIO_VIDEOS = 'studio-videos',
  DRAFT_STUDIO_VIDEOS = 'draft-studio-videos',
  AI_IMAGES = 'ai-images',
  AI_VIDEOS = 'ai-videos',
  INFLUENCERS = 'influencers',
}
